// extracted by mini-css-extract-plugin
module.exports = {"container":"_8a0b4364 _9c40f664","innerContainer":"_9dc8f27a","addProjectIcon":"_ee1f425c","addProject":"_3e6d6457"};